import styled from 'styled-components';
import { mapColors } from '../../slice/map-constants';
import { Card as AntCard } from 'antd';

export const MapWrapper = styled.div`
  font-family: 'SF';
  min-height: 500px;
  flex: 1;
  position: relative;
  overflow: hidden;
  .leaflet-container {
    height: 100%;
    min-height: 500px;
  }
  .field-marker-icon {
    font-family: 'SF';

    display: flex;
    height: 50px !important;
    .marker-icon {
      font-weight: bold;
      color: ${mapColors.percentage};
      font-size: 10px;
      height: 38px !important;
      min-width: 38px !important;
      border: unset !important;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .user-marker-icon {
      height: 30px !important;
      min-width: 30px !important;
      background: #74b6f3;
      border: 4px solid #1990ff !important;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .transport-marker-icon {
      border: 3px dashed red !important;
      &.active-transport {
        border: 3px dashed green !important;
      }
    }
    .field-name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .field-info {
      background: ${mapColors.markerBackground};
      margin-left: 5px;
      padding: 3px 5px;
      border-radius: 3px;
      min-width: 125px;
      white-space: nowrap;
    }
    .transport-info {
      background: ${mapColors.markerBackground};
      margin-left: 5px;
      padding: 3px 5px;
      border-radius: 3px;
      min-width: 125px;
      height: 61px;
      white-space: nowrap;
    }
    &.is-selected {
      .marker-icon {
        border: 3px solid ${mapColors.markerSelectedBorderColor}!important;
      }
    }

    .transport-hover-details {
      visibility: hidden;
      opacity: 0;
      transition: visibility 0.3s, opacity 0.3s;
      transition-delay: 0s;
      position: absolute;
      top: 45px;
      left: 0px;
      background: #fff;
      border-radius: 3px;
      min-width: 125px;
      white-space: nowrap;
      padding: 6px 12px;
      .transport-worker-phone {
        color: #8c8c8c;
      }
    }
    &:hover {
      .transport-hover-details {
        visibility: visible;
        opacity: 1;
        transition-delay: 0.5s;
      }
    }
  }

  .marker-icon-cluster {
    height: 38px !important;
    width: 38px !important;
    border-radius: 50%;
    background-color: ${mapColors.markerCluster};
    border: 1px solid #000;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .cluster-count {
      font-weight: bold;
    }
  }
`;

export const Card = styled(AntCard)`
  height: 100%;
`;
